import React, { useState, useRef, useImperativeHandle } from "react";
import {  Tooltip, theme } from "antd";
import {  EditOutlined , PlusCircleFilled } from "@ant-design/icons";
import TSTable from "../../../common/TSTable";
import ColorButton from "../../../common/ColorButton";
import { DELETE } from "../../../frameworks/HttpClient";
import { URL_SETTING, URL_SKIM } from "../../../constants/urls";
import AddLotModal from "./AddPondModal";
import ErrorMessages from "../../../common/ErrorMessages";
import { dateToHumanString } from "../../../frameworks/Util";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";
import AddPondSkimModal from "./AddPondSkimModal";

const PondSkimList = React.forwardRef((props, ref) => {
  const [openAddLotModal, setOpenAddLotModal] = useState(false);
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages , setErrorMessages] = useState(null);
  
  const { token: { colorSuccess, colorWarning }, } = theme.useToken();

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) { 
        setErrorMessages(error.errorMessages);
      }
    }
  };
  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setTarget(record);
    setOpenAddLotModal(true);
  };

  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);
    try {
      await DELETE(`${URL_SKIM.SKIM_POND}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) =>
        (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
            <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                style={{ margin: 5 }}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "ชื่อบ่อสกิม",
      dataIndex: "name",
      key: "name",
      searcher : true,
      align: "center",
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
    {
      title: "วันที่แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
      type="primary"
      override={colorSuccess}
      icon={<PlusCircleFilled />}
      style={{ marginBottom : 10 , float: "right" }}
      onClick={() => setOpenAddLotModal (true)}
      > 
      เพิ่มบ่อสกิม
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={URL_SKIM.SKIM_POND}
        ref={tableRef}
      />
      <AddPondSkimModal
        open={openAddLotModal}
        onClose={() => {
          setOpenAddLotModal(false);
          setTarget(null);
        }}
        onUpdate={() => {
          setOpenAddLotModal(false);
          setTarget(null);
          refreshData();
        }}
        target={target}
      />
    </div>
  );
});

export default PondSkimList;
